import { NodeSpec } from 'prosemirror-model';

import { BaseExtension } from '@lyearn/lygo-core';

import plugins from './plugins';

export default class Blank extends BaseExtension {
  get schema(): NodeSpec {
    return {
      attrs: {
        text: {
          default: null,
        },
      },
      group: 'inline',
      inline: true,
      atom: true,
      selectable: false,
      draggable: false,

      toDOM: (node) => {
        return ['div'];
      },
    };
  }

  plugins = plugins;

  get name(): string {
    return 'blank';
  }
}
